/** @license Guesty v1.5.0
 *
 * This source code is licensed under the ISC license found in the
 * LICENSE file in the root directory of this source tree.
 */
import FormattedMessage from "./FormattedMessage";
import FormattedDate from "./FormattedDate";
import FormattedTime from "./FormattedTime";
import Moment from "./Moment";
import FormattedCurrency from "./FormattedCurrency";
import LocalizationProvider from "./LocalizationProvider";
import withLocalization from "./withLocalization";
import { MomentFormatTypes, warningHandler, getLanguage, intl, init, locales } from "./utils";
export { intl, init, locales, warningHandler, getLanguage, FormattedMessage, FormattedDate, FormattedTime, FormattedCurrency, Moment, LocalizationProvider, withLocalization, MomentFormatTypes };
var locale = {
  intl: intl,
  init: init,
  locales: locales,
  warningHandler: warningHandler,
  getLanguage: getLanguage,
  FormattedMessage: FormattedMessage,
  FormattedDate: FormattedDate,
  FormattedTime: FormattedTime,
  FormattedCurrency: FormattedCurrency,
  Moment: Moment,
  LocalizationProvider: LocalizationProvider,
  withLocalization: withLocalization,
  MomentFormatTypes: MomentFormatTypes
};
export default locale;